import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Flag1500UitFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='' htmlFor='checkbox-flagALtoBajo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='flagAltoBajo'>
          {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagALtoBajo' label='ALTO' />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(Flag1500UitFormGroup)
